"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGuMemberRequest = void 0;
var GetGuMemberRequest = /** @class */ (function () {
    function GetGuMemberRequest() {
    }
    return GetGuMemberRequest;
}());
exports.GetGuMemberRequest = GetGuMemberRequest;
;
//# sourceMappingURL=getGuMember.request.js.map